<template>
<div v-if="podcast">
  <h1>{{podcast.title}}</h1>
  <div>
    <img :src="podcast.artworkUrl" width="250" height="250">
  </div>
  <div class="actions">
    <a :href="feedUrl" class="button">Abonieren</a>
    <a v-clipboard:copy="podcast.feedUrl"
       v-clipboard:success="onCopy" class="button white">{{copyButtonText}}</a>
  </div>

  <h2>Episoden</h2>
  <div v-for="episode in podcast.episodes" :key="episode.id">
    {{episode.title}} [{{episode.size | prettyBytes}}MB]
  </div>
</div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Podcast',
  props: ['id'],
  data() {
    return {
      podcast: null,
      feedUrl: null,
      copyButtonText: 'URL kopieren',
    };
  },
  filters: {
    prettyBytes(bytes) {
      const megabytes = bytes / 1000 / 1000;
      return Math.round((megabytes + Number.EPSILON) * 100) / 100;
    },
  },
  methods: {
    onCopy() {
      this.copyButtonText = 'URL kopiert';
    },
  },
  mounted() {
    axios
      .get(`/api/podcasts/${this.id}`)
      .then((response) => {
        this.podcast = response.data;
        this.feedUrl = this.podcast.feedUrl.replace('https://', '').replace('http://', '');
        this.feedUrl = `podcast://${this.feedUrl}`;
      });
  },
};
</script>

<style scoped>
  a.button,
  input.button {
    text-decoration: none;
    padding: 0.75em 2em;
    border-radius: 2em;
    display: inline-block;
    color: #fff;
    background-color: #4fc08d;
    transition: all 0.15s ease;
    box-sizing: border-box;
    border: 1px solid #4fc08d;
    margin: 10px;
  }
  a.button.white,
  input.button.white {
    background-color: #fff;
    color: #42b983;
    cursor: pointer;
  }
  .actions {
    margin-top: 10px;
  }
</style>
